import { render, staticRenderFns } from "./telhomePage.vue?vue&type=template&id=492cf0c4&scoped=true"
import script from "./telhomePage.vue?vue&type=script&lang=js"
export * from "./telhomePage.vue?vue&type=script&lang=js"
import style0 from "./telhomePage.vue?vue&type=style&index=0&id=492cf0c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492cf0c4",
  null
  
)

export default component.exports